// extracted by mini-css-extract-plugin
export default {"section":"SectionMain_section__Q133D"};